import React, { useEffect, useState } from 'react';
import api from "../../utils/axiosInstance";
import CarrierHeader from '../../components/CarrierHeader';

const CarrierFavourites = () => {
    const [drivers, setDrivers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        const fetchFavourites = async () => {
            setLoading(true);
            try {
                const storedCarrier = localStorage.getItem('carrierUser');
                const carrier = storedCarrier ? JSON.parse(storedCarrier) : null;

                if (!carrier || !carrier._id) {
                    console.error("Carrier ID missing from localStorage");
                    setDrivers([]);
                    setLoading(false);
                    return;
                }

                const response = await api.get(`/interests/favourites/${carrier._id}`);
                if (Array.isArray(response.data)) {
                    setDrivers(response.data);
                } else {
                    setDrivers([]);
                }
            } catch (error) {
                console.error('Failed to load favorites:', error.message);
                setDrivers([]);
            } finally {
                setLoading(false);
            }
        };

        fetchFavourites();
    }, []);

    const handleView = (driver) => {
        setSelectedDriver(driver);
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setSelectedDriver(null);
    };

    return (
        <div className="bg-gray-100 text-dark min-h-screen lg:pl-64">
            <CarrierHeader />

            <div className="max-w-6xl mx-auto px-4 py-8">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Favorite Drivers</h2>

                {loading ? (
                    <div className="text-center py-20 text-xl text-gray-500">Loading...</div>
                ) : drivers.length === 0 ? (
                    <div className="text-center py-20 text-xl text-gray-500">No favorites found.</div>
                ) : (
                    <div className="overflow-x-auto">
                        <table className="w-full bg-white rounded-lg shadow-md overflow-hidden">
                            <thead>
                                <tr className="bg-gray-200 text-gray-700">
                                    <th className="p-4 text-left">Name</th>
                                    <th className="p-4 text-left">Experience</th>
                                    <th className="p-4 text-left">Route</th>
                                    <th className="p-4 text-left">CDL</th>
                                    <th className="p-4 text-left">Address</th>
                                    <th className="p-4 text-left">Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {drivers.map((d) => (
                                    <tr key={d._id} className="border-b hover:bg-gray-50">
                                        <td className="p-4">{d.name}</td>
                                        <td className="p-4">{d.experience}</td>
                                        <td className="py-4 px-2">{Array.isArray(d.route) ? d.route.join(', ') : d.route}</td>
                                        <td className="p-4">{d.cdl}</td>
                                        <td className="p-4">{`${d.address}, ${d.city}, ${d.state} ${d.zip}`}</td>
                                        <td className="p-4">
                                            <button
                                                onClick={() => handleView(d)}
                                                className="inline-block bg-blue-600 hover:bg-black text-white px-3 py-1 rounded text-sm font-medium"
                                            >
                                                View
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>

            {/* Modal */}
            {isModalOpen && selectedDriver && (
                <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                    <div className="bg-white w-full max-w-lg rounded-lg shadow-lg p-6 relative">
                        <button
                            onClick={handleCloseModal}
                            className="absolute top-2 right-2 text-gray-600 hover:text-blue-600 text-2xl font-bold"
                        >
                            &times;
                        </button>

                        <h2 className="text-2xl font-semibold mb-4 text-gray-800">Driver Details</h2>

                        <div className="grid grid-cols-2 gap-4 text-gray-700 text-sm mb-4">
                            <p><strong>Name:</strong> {selectedDriver.name}</p>
                            <p><strong>Email:</strong> {selectedDriver.email}</p>
                            <p><strong>Phone:</strong> {selectedDriver.phone}</p>
                            <p><strong>Experience:</strong> {selectedDriver.experience}</p>
                            <p><strong>Route:</strong>{Array.isArray(selectedDriver.route) ? selectedDriver.route.join(', ') : selectedDriver.route}</p>
                            <p><strong>Job:</strong> {selectedDriver.job}</p>
                            <p><strong>Trailer:</strong>{Array.isArray(selectedDriver.trailer) ? selectedDriver.trailer.join(', ') : selectedDriver.trailer}</p>
                            <p><strong>CDL:</strong> {selectedDriver.cdl}</p>
                            <p><strong>Endorsements:</strong> {Array.isArray(selectedDriver.endorsements) ? selectedDriver.endorsements.join(', ') : selectedDriver.endorsements}</p>
                            <p><strong>Address:</strong> {selectedDriver.address}</p>
                            <p><strong>City:</strong> {selectedDriver.city}</p>
                            <p><strong>State:</strong> {selectedDriver.state}</p>
                            <p><strong>ZIP:</strong> {selectedDriver.zip}</p>
                        </div>
                    </div>
                </div>
            )
            }
        </div >
    );
};

export default CarrierFavourites;
